// 船期查询聚合版国际化 - 中文
export default {
  title: '船期查询（聚合版）',
  description: '聚合展示直航和中转船期信息',

  // 搜索区域
  search: {
    title: '船期查询',
    originPort: '起运港',
    destinationPort: '目的港',
    etd: 'ETD',
    searchButton: '搜索',
    selectOriginPort: '请选择起运港',
    selectDestinationPort: '请选择目的港',
    selectDate: '选择日期'
  },

  // 船期类型卡片
  scheduleType: {
    direct: '直航船期',
    transit: '中转船期',
    vesselGroups: '{count} 组船',
    carriers: '{count} 家船公司',
    schedules: '{count} 条船期',
    solutionCount: '{count} 种转运方式'
  },

  // 筛选
  filter: {
    carrier: '船公司',
    originTerminal: '起运港码头',
    destTerminal: '目的港码头'
  },

  // 船期列表组
  scheduleGroup: {
    weekday: '船期',
    duration: '航程',
    durationRange: '航程',
    sharedCarriers: '船公司',
    carrier: '船公司',
    solutionCount: '方案数'
  },

  // 详情标签
  detailTabs: {
    ai: 'AI 船期',
    localFee: '本地费用',
    route: '挂靠路径'
  },

  // 船期明细
  scheduleDetail: {
    vessel: '船名',
    voyage: '航次',
    originPort: '起运港',
    destPort: '目的港',
    terminal: '码头',
    etd: 'ETD',
    eta: 'ETA',
    duration: '天',
    firstTransitPort: '首个中转港',
    operationTime: '操作时间',
    inquiry: '询价',
    matchRate: '匹配运价',
    transitDetail: '中转详情',
    loadMore: '点击加载更多船期信息',
    shareCabinDetail: '共舱详情'
  },

  // 共舱详情弹窗
  shareCabinDetail: {
    title: '共舱详情',
    durationText: '航程 {duration} 天',
    carrier: '船公司',
    routeCode: '航线代码',
    voyage: '航次',
    mainCarrier: '主船公司'
  },

  // 操作时间弹窗
  operationTime: {
    title: '操作时间',
    bookingCutoff: '截订舱时间',
    cyOpen: '进港时间',
    cyClose: '截港时间',
    customCutoff: '截放行时间',
    cutOff: '截关时间',
    siCutoff: '截提单时间',
    vgmCutoff: '截VGM时间',
    disclaimer: '以上操作时间仅供参考\n实际请以码头和船公司公告为准'
  },

  // 中转详情弹窗
  transitDetail: {
    title: '中转详情',
    transit1Port: '中转港1',
    transit1Route: '中转港1航线代码',
    transit1Vessel: '中转港1船名航次',
    transit2Port: '中转港2',
    transit2Route: '中转港2航线代码',
    transit2Vessel: '中转港2船名航次',
    vesselVoyage: '船名航次',
    routeCode: '航线代码',
    arrival: '到港',
    departure: '离港',
    transitBadge: '中转'
  },

  // 挂靠路径
  route: {
    startPort: '起始港',
    endPort: '目的港',
    transitPort: '中转港',
    days: '天'
  },

  // 本地费用
  localFee: {
    feeName: '费用名称',
    perTicketPrice: '单票价格',
    disclaimer: '以上费用仅供参考，具体请以船公司公告为准',
    gp20: '20\'GP',
    gp40: '40\'GP',
    hq40: '40\'HQ',
    hq45: '45\'HQ',
    rf20: '20\'RF',
    otfr20: '20\'OT/FR',
    rh40: '40\'RH',
    otfr40: '40\'OT/FR'
  },

  // 船舶信息提示
  vesselInfo: {
    name: '船名',
    imo: 'IMO',
    mmsi: 'MMSI',
    callSign: '呼号',
    terminal: '码头'
  },

  // 星期枚举
  weekdays: {
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周日'
  },

  // 港口选择器
  portSelector: {
    emptyPorts: '暂无港口数据',
    other: '其他'
  },

  // 消息提示
  messages: {
    selectPorts: '请选择起运港和目的港',
    loadFailed: '加载数据失败，请稍后重试',
    emptyResult: '暂无数据'
  }
}
